import { Box, CircularProgress, Container } from '@mui/material';
import React from 'react';

import {
  FullScreenLoaderMainStyles,
  FullScreenLoaderWrapperStyles,
} from '@/components/fullScreenLoader/styles/fullScreenLoader.styles.ts';

export const FullScreenLoader: React.FC = () => {
  return (
    <Container sx={FullScreenLoaderMainStyles}>
      <Box sx={FullScreenLoaderWrapperStyles}>
        <CircularProgress />
      </Box>
    </Container>
  );
};
